import { createContext } from 'react';
import { IAssembleiasAssessorEvent } from 'store/modules/AssembleiasAssessorReducer';
import { ListaPerguntaResponse, PerguntaResponse } from 'api/Assessor/duvidas';

export interface UserAuth {
  ver: boolean;
  responder: boolean;
  incluirPergunta: boolean;
  alterarSituacao: boolean;
}

interface AssessorMensagensContext {
  evento: IAssembleiasAssessorEvent | null;
  conversas: ListaPerguntaResponse;
  conversaAtual: PerguntaResponse | null;
  irParaConversa: (cpfUsuario: string) => void;
  atualizarMensagens: (
    successCb?: (conversas: ListaPerguntaResponse) => void
  ) => void;
  pesquisar: (termo: string) => void;
  atualizarEvento: () => void;
  termoPesquisa?: string;
  auth?: UserAuth;
  habilitandoDesabilitando: boolean;
}

export default createContext<AssessorMensagensContext>({
  evento: null,
  conversas: [],
  conversaAtual: null,
  irParaConversa: () => ({}),
  atualizarMensagens: () => ({}),
  pesquisar: () => ({}),
  atualizarEvento: () => ({}),
  habilitandoDesabilitando: false,
});
